import React from 'react';
import { Box, Text, HStack, Link, Divider, VStack } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n';

const PRE_LOGIN_ROUTES = new Set(['/', '/demo', '/login', '/register', '/platform', '/reset-password', '/verify-otp']);

const legalLinks = [
  { labelKey: 'footer.legal.privacy', href: 'https://www.finansee.eu/privacy-policy' },
  { labelKey: 'footer.legal.terms', href: 'https://www.finansee.eu/terms-of-use' },
  { labelKey: 'footer.legal.cookies', href: 'https://www.finansee.eu/cookies-policy' },
  { labelKey: 'footer.legal.disclaimer', href: 'https://www.finansee.eu/legal-disclaimer' },
];

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isPreLogin = PRE_LOGIN_ROUTES.has(location.pathname);
  const supportColor = isPreLogin ? 'brand.quantumAccent' : 'brand.teal';
  const supportHover = isPreLogin ? 'brand.quantumCyan' : 'teal.200';

  return (
    <Box
      bg={isPreLogin ? '#060a14' : 'brand.navy'}
      borderTop="1px solid"
      borderColor={isPreLogin ? 'brand.quantumBorder' : 'whiteAlpha.200'}
      py={6}
      mt="auto"
    >
      <Box maxW="container.xl" mx="auto" px={6}>
        <VStack spacing={isPreLogin ? 3 : 0}>
          <HStack
            spacing={4}
            justify="center"
            align="center"
            flexWrap="wrap"
          >
            <Text color="whiteAlpha.700" fontSize="sm">
              {t('footer.rights', { year: new Date().getFullYear() })}
            </Text>
            <Divider orientation="vertical" h="16px" borderColor="whiteAlpha.300" />
            <Text color="whiteAlpha.700" fontSize="sm">
              {t('footer.support')}{' '}
              <Link
                href="mailto:info@finansee.eu"
                color={supportColor}
                _hover={{ color: supportHover, textDecoration: 'underline' }}
              >
                info@finansee.eu
              </Link>
            </Text>
          </HStack>

          {isPreLogin ? (
            <VStack spacing={2}>
              <HStack spacing={3} justify="center" flexWrap="wrap">
                {legalLinks.map((item) => (
                  <Link
                    key={item.href}
                    href={item.href}
                    isExternal
                    color="whiteAlpha.700"
                    fontSize="sm"
                    _hover={{ color: 'brand.quantumAccent', textDecoration: 'none' }}
                  >
                    {t(item.labelKey)}
                  </Link>
                ))}
              </HStack>
              <Text color="whiteAlpha.600" fontSize="sm" textAlign="center">
                {t('footer.dpa')}{' '}
                <Link href="mailto:compliance@finansee.eu" color="brand.quantumAccent" _hover={{ color: 'brand.quantumCyan' }}>
                  compliance@finansee.eu
                </Link>
              </Text>
            </VStack>
          ) : null}
        </VStack>
      </Box>
    </Box>
  );
};

export default Footer;
